import { buildMapConfig } from '../../services/location-service';

export default class PostPresenter {
  constructor(model, view, appInterface) {
    this.model = model;
    this.view = view;
    this.appInterface = appInterface;
    this.postId = null;
  }

  async init(postId) {
    this.postId = postId;
    this.model.loadUserState();
    if (this.view.setPostId) this.view.setPostId(postId);
    if (this.view.showLoading) this.view.showLoading('#single-post-container');

    if (!this.model.isAuthenticated) {
      if (this.view.showAuthRequired) {
        this.view.showAuthRequired('#single-post-container', () =>
          this.appInterface.navigateTo('auth')
        );
      }
      return;
    }

    try {
      const story = await this.model.getStoryDetail(postId);
      const isBookmarked = this.model.isBookmarked(postId);
      this.view.renderPost(story, isBookmarked);

      if (story.lat && story.lon) {
        const isDark = this.view.isDarkMode ? this.view.isDarkMode() : false;
        const config = buildMapConfig('single-post-map', isDark, this.model.getCurrentMapLayer());
        config.center = [story.lon, story.lat];
        config.zoom = 15;
        this.view.initializeMap(config);
        this.view.addMapLayerControl((layer) => this.changeLayer(layer), this.model.getCurrentMapLayer());
        this.view.addMarker(
          story.lon,
          story.lat,
          `<div style="padding:0.5rem;text-align:center;"><h4 style="margin:0 0 0.5rem 0;">${story.name}</h4><p style="margin:0;font-size:0.875rem;">Lokasi postingan</p></div>`
        );
        const locationName = await this.model.getLocationName(story.lat, story.lon);
        this.view.updateLocationName(story.id, locationName);
      }

      if (this.view.setupPostInteractionEventListeners) {
        this.view.setupPostInteractionEventListeners(
          (id) => this.toggleBookmark(id),
          (id) => this.sharePost(id),
          (src) => this.appInterface.showLightbox(src)
        );
      }

      if (this.appInterface.reinitTooltips) this.appInterface.reinitTooltips();
    } catch (e) {
      if (this.view.showError) {
        this.view.showError('#single-post-container', 'Gagal memuat postingan');
      }
    }
  }

  changeLayer(layerType) {
    const isDark = this.view.isDarkMode ? this.view.isDarkMode() : false;
    const styleUrl = this.model.getMapStyleConfig(isDark, layerType);
    this.model.setCurrentMapLayer(layerType);
    this.view.setMapStyle(styleUrl, () => this.view.updateLayerSelection(layerType));
  }

  toggleBookmark(storyId) {
    const isBookmarked = this.model.isBookmarked(storyId);
    if (isBookmarked) {
      if (this.model.removeBookmark(storyId)) {
        this.appInterface.setBookmarks([...this.model.bookmarks]);
        this.appInterface.updateBookmarkBubble();
        this.view.updateBookmarkStatus(storyId, false);
        this.appInterface.showToast('Postingan dihapus dari bookmark', 'success');
      }
    } else {
      if (!this.model.isAuthenticated) {
        this.appInterface.showToast('Masuk terlebih dahulu untuk menyimpan', 'warning');
        return;
      }
      const bookmark = this.model.addBookmark();
      if (bookmark) {
        this.appInterface.setBookmarks([...this.model.bookmarks]);
        this.appInterface.updateBookmarkBubble();
        this.view.updateBookmarkStatus(storyId, true);
        this.appInterface.showToast('Postingan berhasil disimpan', 'success');
      }
    }
  }

  sharePost(storyId) {
    const url = `${this.appInterface.getCurrentUrl()}#/share/${storyId}`;
    this.appInterface.setShareUrl(url);
    this.appInterface.showDialog('share-dialog');
  }

  cleanup() {
    if (this.view.cleanup) this.view.cleanup();
  }
}
